import { render, staticRenderFns } from "./sbujk.vue?vue&type=template&id=076fa95d&scoped=true&"
import script from "./sbujk.vue?vue&type=script&lang=js&"
export * from "./sbujk.vue?vue&type=script&lang=js&"
import style0 from "./sbujk.vue?vue&type=style&index=0&id=076fa95d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076fa95d",
  null
  
)

export default component.exports